import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import { formattedWallet } from "../../../utils/account";
import { getCompleteDate } from "../../../utils/util";

import "./auctionRecordsStyles.css";

const AuctionRecords = ({ records }) => {
  const noRecords = !records || records.length === 0;

  return (
    <div className="auction-records text-center">
      <span className="title">Auction Records</span>
      <div className="table-auction-records">
        <Container
          className={`table-auction-records-container ${
            noRecords ? "my-2 p-3" : ""
          }`}
        >
          {noRecords ? (
            <Row className="no-records justify-content-center mx-auto">
              <Col>
                <span>
                  Auction records will show once other users place bids
                </span>
              </Col>
            </Row>
          ) : (
            records.map((record, index) => (
              <Row
                key={index}
                className={index % 2 === 0 ? "row-even" : "row-odd"}
              >
                <Col xs={3} md={4}>
                  <Row className="justify-content-center">
                    <span className="row-title">Bidder</span>
                  </Row>
                  <Row className="justify-content-center">
                    <span className="row-value">
                      {formattedWallet(record.wallet)}
                    </span>
                  </Row>
                </Col>
                <Col xs={4} md={4}>
                  <Row className="justify-content-center">
                    <span className="row-title">Price</span>
                  </Row>
                  <Row className="justify-content-center">
                    <span className="row-value">{record.value} GEO$</span>
                  </Row>
                </Col>
                <Col xs={5} md={4}>
                  <Row className="justify-content-center">
                    <span className="row-title">Date</span>
                  </Row>
                  <Row className="justify-content-center">
                    <span className="row-value">
                      {getCompleteDate(new Date(record.date))}
                    </span>
                  </Row>
                </Col>
              </Row>
            ))
          )}
        </Container>
      </div>
    </div>
  );
};

export default AuctionRecords;
